// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import VueApexCharts from "vue-apexcharts";

// start loading overlay
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(Loading);
// end loading overlay

// start font awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faEdit,
  faTrashAlt,
  faSearch,
  faCalendarAlt,
  faSync,
  faUndo,
  faBox,
  faCamera,
  faArrowUp,
  faArrowDown,
  faFileExport
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faPlus);
library.add(faEdit);
library.add(faTrashAlt);
library.add(faSearch);
library.add(faCalendarAlt);
library.add(faUndo);
library.add(faBox);
library.add(faSync);
library.add(faCamera);
library.add(faArrowUp);
library.add(faArrowDown);
library.add(faFileExport);
Vue.component("font-awesome-icon", FontAwesomeIcon);
// end font awesome

// start bootstrap
import "bootstrap-vue/dist/bootstrap-vue.css";
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
// end bootstrap

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

// import 'bootstrap';
// import 'summernote/dist/summernote-bs4.css';
// // import summernote from 'summernote';
// import summernote from 'summernote/dist/summernote-bs4.js';
// Vue.use(summernote);

// start config
Vue.config.productionTip = false;
Vue.config.env = process.env;
// end config

Vue.prototype.$http = axios;

window.eventHub = new Vue();
Vue.prototype.$eventHub = window.eventHub;

// start Vuex
import Vuex from "vuex";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user_obj: false
  },
  mutations: {},
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status
  }
});

// session token
router.beforeEach(async (to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  let loggedIn = localStorage.getItem("user_obj");

  if (loggedIn) {
    let tmp_user_obj = JSON.parse(localStorage.getItem("user_obj"));
    if (!tmp_user_obj.permissions) {
      localStorage.removeItem("user_obj");
      loggedIn = false;
    }
  }

  if (authRequired && !loggedIn) {
    return next("/login");
  } else if(to.path != "/login"){
    store.state.user_obj = JSON.parse(localStorage.getItem("user_obj"));

    axios({
      method: "POST",
      baseURL: `${process.env.VUE_APP_API_HOST}`,
      url: "user_permission_get.php",
      data: {
        user_id: store.state.user_obj.user_id
      }
    }).then(r => {
      // console.log(r);
      // console.log(store.state.user_obj);

      localStorage.setItem(
        "user_obj",
        JSON.stringify({
          user_id: store.state.user_obj.user_id,
          user_name: store.state.user_obj.username,
          account_type: store.state.user_obj.account_type,
          name: store.state.user_obj.name,
          permissions: store.state.user_obj.permissions,
          sys_permissions: r.data.sys_permissions,
          client_id: store.state.user_obj.client_id,
          first_time_login: store.state.user_obj.first_time_login,
          client_profile: r.data.client_profile,
        })
      );

      store.state.user_obj = {
        user_id: store.state.user_obj.user_id,
          user_name: store.state.user_obj.username,
          account_type: store.state.user_obj.account_type,
          name: store.state.user_obj.name,
          permissions: store.state.user_obj.permissions,
          sys_permissions: r.data.sys_permissions,
          client_id: store.state.user_obj.client_id,
          first_time_login: store.state.user_obj.first_time_login,
          client_profile: r.data.client_profile,
      };
    });
  }

  next();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js